
import ChitPoolChart from "./ChitPoolChart";
import LoanChart from "./LoanChart";
import MonthlyInterestChart from "./MonthlyInterestChart";
import PieCharts from "./PieCharts";
import { ChitPool, Loan } from "@/lib/types";

interface OverviewContentProps {
  chitPoolData: Array<{
    name: string;
    amount: number;
  }>;
  loanData: Array<{
    name: string;
    amount: number;
    interest: number;
  }>;
  interestData: Array<{
    month: string;
    interest: number;
  }>;
  pieChartData: Array<{
    name: string;
    value: number;
  }>;
  portfolioValueData: Array<{
    name: string;
    value: number;
  }>;
  formatCurrency: (amount: number) => string;
}

const OverviewContent = ({ 
  chitPoolData, 
  loanData, 
  interestData, 
  pieChartData, 
  portfolioValueData,
  formatCurrency
}: OverviewContentProps) => {
  return (
    <div className="grid gap-6 md:grid-cols-2">
      <ChitPoolChart data={chitPoolData} />
      <LoanChart data={loanData} />
      <MonthlyInterestChart data={interestData} />
      <PieCharts 
        pieChartData={pieChartData} 
        portfolioValueData={portfolioValueData} 
        formatCurrency={formatCurrency} 
      />
    </div>
  );
};

export default OverviewContent;
